import { AppKeys, getIAMUXBaseAddress, getUrlForApp } from '@microsoft/portal-app/lib/environment';
import { NAVIGATION_LINKS, MSGraphScopes, MY_GROUPS_PATH, RETRIEVING_CREDENTIALS } from './constants';
import { settingsManager } from './settings';
import { ViewportType, viewportTypes } from '@amx/ux-twoui';

export const guestAccountCheck = (userPrincipalName: string) => {
  return userPrincipalName.includes('#EXT#@') || userPrincipalName.includes('_EXT_@');
};

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);

  const binaryStr = bytes.reduce((data, byte) => {
    return data + String.fromCharCode(byte);
  }, '');

  return btoa(binaryStr);
};

export const isLeftNavInvisible = () => {
  const pathname = window.location.pathname;
  const isLeaveOrgRoute = pathname.includes('organizations/leave');
  const isMyGroups = pathname.startsWith(MY_GROUPS_PATH);
  const isTermsOfUseConsent = pathname.startsWith(NAVIGATION_LINKS.termsOfUse.subRoutePaths!.consent.link);
  const urlParams = new URLSearchParams(window.location.search);
  const isRetrievingCredentials = urlParams.has(RETRIEVING_CREDENTIALS);

  return isLeaveOrgRoute || isMyGroups || isTermsOfUseConsent || isRetrievingCredentials;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

export const getMSGraphScopeAndEndPoint = (scope: MSGraphScopes) => {
  const MSGraphEndPoint = settingsManager.getRequired('msGraphResourceName');
  // being more defensive here just in case the msGraphResourceName format is changed in the future
  const finalScope = MSGraphEndPoint.endsWith('/') ? `${MSGraphEndPoint}${scope}` : `${MSGraphEndPoint}/${scope}`;
  return {
    scope: finalScope,
    MSGraphEndPoint,
  };
};

export const getAppKey = (link: string): AppKeys => {
  switch (link) {
    case AppKeys.apps:
      return AppKeys.apps;
    case AppKeys.groups:
      return AppKeys.groups;
    case AppKeys.account:
      return AppKeys.account;
    case AppKeys.signins:
      return AppKeys.signins;
  }
  return AppKeys.signins;
};

export const createUrl = (
  link: string,
  isInternalLink: boolean,
  isIamuxLink: boolean,
  path?: string,
  tenantId?: string,
  upn?: string,
): string => {
  if (isInternalLink) {
    return link;
  }

  let url: URL;
  if (isIamuxLink) {
    url = getIAMUXBaseAddress(location);
    url.pathname = link;
    if (tenantId) {
      url.searchParams.set('tenant', tenantId);
    }
  } else {
    url = getUrlForApp(location, getAppKey(link));
    if (path) {
      url.pathname = path;
    }
    if (tenantId) {
      url.searchParams.set('tenant', tenantId);
    }
    if (upn) {
      url.searchParams.set('upn', upn);
    }
  }

  return url.toString();
};

// convert: https://microsoft.visualstudio.com/Universal%20Store/_git/XS.AMC.UX?path=/packages/ux-twoui/src/styles/media.ts&version=GBmaster&line=58&lineEnd=58&lineStartColumn=7&lineEndColumn=33&lineStyle=plain&_a=contents
// export declare const viewportTypes: readonly ["s", "m", "l", "xl", "xxl", "xxxl"];
export const getViewportTypeIndex = (viewportType: ViewportType) => {
  return viewportTypes.indexOf(viewportType);
};
